export default [
  'apafree6',
]